(function ($) {
   if (document.readyState !== 'loading') {
      main_init();
   } else {
      document.addEventListener('DOMContentLoaded', function () {
         main_init();
      });
   }

   function main_init() {
      // Function to scroll smoothly to the element
      function smoothScrollToHash(hash) {
         var target = $(hash);
         if (target.length) {
            $('html, body').animate(
               { scrollTop: target.offset().top - 100 },
               800, // Duration in milliseconds
            );
         }
      }

      // Scroll on page load if there's a hash in the URL
      if (window.location.hash) {
         smoothScrollToHash(window.location.hash);
      }

      // Smooth scrolling when clicking anchor links
      $('a[href^="#"]').on('click', function (e) {
         e.preventDefault();
         var hash = this.hash;
         if (hash) {
            smoothScrollToHash(hash);
            history.pushState(null, null, hash); // Update URL without reloading
         }
      });

      setTimeout(function () {
         $('.hero-animation-container > .hero-animation-green-bg').addClass(
            'active',
         );
         setTimeout(function () {
            $('.hero-animation-container  .hero-animation-tristess').addClass(
               'active',
            );
            setTimeout(function () {
               $('.hero-animation-container  .hero-animation-so-long').addClass(
                  'active',
               );
               setTimeout(function () {
                  $(
                     '.hero-animation-container  .hero-animation-tristess',
                  ).addClass('tilted');
                  $(
                     '.hero-animation-container  .hero-animation-so-long',
                  ).addClass('tilted');
                  setTimeout(function () {
                     $(
                        '.hero-animation-container  .hero-animation-kid',
                     ).addClass('active');
                     setTimeout(function () {
                        $(
                           '.hero-animation-container  .hero-animation-checka-in-butikerna',
                        ).addClass('active');
                        setTimeout(function () {
                           $(
                              '.hero-animation-container  .hero-animation-lunch',
                           ).addClass('active');
                           setTimeout(function () {
                              $(
                                 '.hero-animation-container  .hero-animation-erbjudanden',
                              ).addClass('active');
                              setTimeout(function () {
                                 $(
                                    '.hero-animation-container  .hero-animation-6-timmars-parkering',
                                 ).addClass('active');
                              }, 200);
                           }, 200);
                        }, 200);
                     }, 200);
                  }, 250);
               }, 250);
            }, 500);
         }, 500);
      }, 500);
   }
})(jQuery);
